MultiStepForm[4] = {
  occupation: false,
  neto_income: false,
  monthly_expenses: false,
  remuneration_deadline: false,
}

let dates = {
  remuneration_deadline: "",
  employment_start_date: "",
}

const regex_numeric = /^[0-9\s]+$/i
// const regex_car_plate_number = /^\d{4}\s*[BCDFGHJKLMNPRSTVWXYZ]{3}|[A-Z]{2,3}\s*\d{4}\s*[A-Z]{2}$/  old regex
const regex_car_plate_number = /^[0-9]{4}\s?[BCDFGHJKLMNPRSTVWXYZbcdfghjklmnprstvwxyz]{3}$/

const validateIncome = (value) => {
  return regex_numeric.test(value)
}

const validateCarPlateNumber = (value) => {
  return regex_car_plate_number.test(value)
}

const validateRemunerationDeadline = () => {
  const day = document.getElementById("remuneration_deadline-day").value
  const month = document.getElementById("remuneration_deadline-month").value
  const year = document.getElementById("remuneration_deadline-year").value

  const value = day + "-" + month + "-" + year
  if (value !== "" && value.length == 10) {
    dates.remuneration_deadline = value
    const remunerationDeadline = moment(value, "DD-MM-YYYY")
    return moment().isSameOrBefore(remunerationDeadline)
  }

  return false
}

const validateEmploymentStartDate = () => {
  const day = document.getElementById("employment_start_date-day").value
  const month = document.getElementById("employment_start_date-month").value
  const year = document.getElementById("employment_start_date-year").value

  const value = day + "-" + month + "-" + year
  if (value !== "" && value.length == 10) {
    dates.employment_start_date = value
    const employmentStartDate = moment(value, "DD-MM-YYYY")
    return moment().isSameOrAfter(employmentStartDate)
  }

  return false
}

jQuery(document).ready(function ($) {
  // Car Owner Event
  const $carOwnerRadioButtons = $('#LeadForm-car_owner input[type="radio"]');
  $("body").on("click", $carOwnerRadioButtons, function (event) {
    const $this = $(event.target).children();

    if ($this.prop("type") == "radio" && ["YES", "NO"].includes($this.prop("id"))) {
      if ($this.prop("id") == "YES") {
        $("#LeadForm-car_owner label.btn-default.YES").addClass("active");
        $("#LeadForm-car_owner label.btn-default.NO").removeClass("active");

        
        $(".field-LeadForm-car_plate_number").removeClass("has-error")
      } else {
        $("#LeadForm-car_owner label.btn-default.YES").removeClass("active");
        $("#LeadForm-car_owner label.btn-default.NO").addClass("active");
      }

      showSuccess(3, "car_owner");
      $("#form-toggle-car_owner").val($this.prop("id"));

      if ($this.prop("id") === "YES") {
        $(".field-LeadForm-car_plate_number").show();
        MultiStepForm[4].car_plate_number = false
        // validateCarPlateNumberField();
      } else {
        $(".field-LeadForm-car_plate_number").hide();
        $("#LeadForm-car_plate_number").val(""); // Clear car plate number field
        $(".field-LeadForm-car_plate_number").removeClass("has-error has-success"); // Remove error/success classes
        delete MultiStepForm[4].car_plate_number; // Remove error/success classes
      }
    }
  });

  const validateCarPlateNumberField = () => {
    const carOwnerValue = $("#form-toggle-car_owner").val()
    const carPlateNumber = $("#LeadForm-car_plate_number").val()
    const isValid = validateCarPlateNumber(carPlateNumber);

    if( carOwnerValue == "YES" ) {
      if (isValid) {
        // If valid, add success class and remove error class
        $(".field-LeadForm-car_plate_number").removeClass("has-error").addClass("has-success");
        MultiStepForm[4].car_plate_number = true; // Update car_plate_number field in the form object
      } else {
        // If not valid, add error class and remove success class
        $(".field-LeadForm-car_plate_number").removeClass("has-success").addClass("has-error");
        MultiStepForm[4].car_plate_number = false; // Update car_plate_number field in the form object
      }
    }
    
  };

  $("body").on("keyup", "#LeadForm-car_plate_number", function () {
    validateCarPlateNumberField();
  });

  $("body").on("change", "#form-toggle-step-4 #LeadForm-car_owner", function () {
    const name = $(this).data("name")
    const field = $(this).data("label").toLowerCase()

    const button = $(`#LeadForm-${name} label.btn-default`)
    if (button.hasClass("active")) {
      showSuccess(3, name)
    } else {
      const message = `Por favor, selecciona tu ${field}.`
      showError(3, name, field, "", message)
    }
  })

  $("body").on("keyup", "#form-input-step-4 input", function () {
    const value = $(this).val()
    const name = $(this).data("name")
    const field = $(this).data("label").replace(/-/g, " ").toLowerCase()

    let success = false

    if (["neto_income", "monthly_expenses"].includes(name)) {
      var inputElement = $(this)
      var maskedValue = inputElement.val().replace(/[^\d]/g, '')
      maskedValue = Math.min(maskedValue, 10000);
      inputElement.val(maskedValue)

      success = validateIncome(maskedValue)
    }

    if (name == "car_plate_number") {
      success = validateCarPlateNumber(value)
    }

    if (success) {
      showSuccess(4, name)
    } else {
      showError(4, name, field, value)
    }
  })

  $("body").on("change", "#form-date-step-4 select", function (event) {
    const name = $(event.target).data("name")

    let field = ""
    let success = false

    if (name == "remuneration_deadline") {
      success = validateRemunerationDeadline()
      field = "fecha límite del próximo sueldo"
    }

    if (name == "employment_start_date") {
      success = validateEmploymentStartDate()
      field = "empleo fecha de inicio"
    }

    if (success) {
      $(`#LeadForm-${name}`).val(dates[name])
      showSuccess(4, name)
    } else {
      const message = `Por favor, selecciona tu ${field}.`
      showError(4, name, "", "", message)
    }
  })
  

  $("body").on("change", "#form-selector-step-4 select", function () {
    const value = $(this).val()
    const name = $(this).data("name")
    const field = $(this).data("label").replace(/-/g, " ").toLowerCase()

    if (!MultiStepForm[4].car_plate_number) {
      if (name == "car_owner") {
        if (value == "YES") {
          MultiStepForm[4].car_plate_number = false
          $(".field-LeadForm-car_plate_number").show()
        } else {
          $("#LeadForm-car_plate_number").val("")
          $(".field-LeadForm-car_plate_number").removeClass("has-error")
          $(".field-LeadForm-car_plate_number").removeClass("has-success")
          $(".field-LeadForm-car_plate_number").hide()

          delete MultiStepForm[4].car_plate_number
        }
      }
    }

    // if (!MultiStepForm[4].employment_start_date) {
      if (name == "occupation") {
        if (value == "EMPLOYED_INDEFINITE_PERIOD") {
          MultiStepForm[4].employment_start_date = false
          $(".field-LeadForm-employment_start_date").show()
        } else {
          $("#employment_start_date-day").val("")
          $("#employment_start_date-month").val("")
          $("#employment_start_date-year").val("")
          $(".field-LeadForm-employment_start_date").removeClass("has-error")
          $(".field-LeadForm-employment_start_date").removeClass("has-success")
          $(".field-LeadForm-employment_start_date").hide()

          delete MultiStepForm[4].employment_start_date
        }
      }
    // }

    // if (!MultiStepForm[4].job_area) {
      if (name == "occupation") {
        if (["EMPLOYED_INDEFINITE_PERIOD", "ECONOMIC_ACTIVITY", "MATERNITY_LEAVE", "PENSIONER1"].includes(value)) {
          MultiStepForm[4].job_area = false
          $(".field-LeadForm-job_area").show()
        } else {
          $("#LeadForm-job_area").val("");
          $(".field-LeadForm-job_area").removeClass("has-error")
          $(".field-LeadForm-job_area").removeClass("has-success")
          $(".field-LeadForm-job_area").hide()

          delete MultiStepForm[4].job_area
        }
      }
    // }

    if (value) {
      showSuccess(4, name)
    } else {
      const message = `Por favor, selecciona tu ${field}.`
      showError(4, name, field, value, message)
    }
  })

  $("body").on("click", "#submit-button-step-4", function (event) {
    event.preventDefault()
    submitForm(4)
  })

  $("body").on("click", "#previous-button-step-4", function (event) {
    event.preventDefault()
    showPreviousForm(3)
  })

  $("body").on("click", "#mobile-previous-button-step-4", function (event) {
    event.preventDefault()
    showPreviousForm(3)
  })

  $("body").on("click", "#sidebar-step-3", function (event) {
    event.preventDefault()
    showPreviousForm(3, "sidebar")
  })
})
